// removed by extract-text-webpack-plugin
module.exports = {"Allocations":"Allocations__Allocations__QYI6g"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Allocations/Allocations.css
// module id = 499
// module chunks = 0